<nav class="navbar navbar-expand-md navbar-dark bg-primary ">
  <div class="container-fluid">
    <!-- <a class="navbar-brand">ERV</a> -->
    <button class="navbar-toggler" type="button"  data-toggle="collapse" data-target="#navbarCollapse"
      aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav me-auto mb-2 mb-md-0">
        <li *ngIf="(user) && isAdmin" class="nav-item">
          <a routerLink="danh-sach-dang-ky-kiem-hoa" class="nav-link">Danh sách đăng ký kiểm hóa</a>
        </li>
        <li *ngIf="(user) && isAdmin" class="nav-item">
          <a routerLink="danh-sach-cbcc" class="nav-link">Danh sách CBCC</a>
        </li>
        <li class="nav-item">
          <a routerLink="dang-ky-kiem-hoa" class="nav-link">Đăng ký</a>
        </li>
        <li class="nav-item">
          <a routerLink="tim-kiem" class="nav-link">Tìm kiếm</a>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right ">
        <li *ngIf="!(user)"><a (click)="login()" class="nav-link">Đăng nhập</a></li>
        <li *ngIf="(user)"><a class="nav-link">{{user.displayName}}</a></li>
        <li *ngIf="(user)"><a (click)="logout()" class="nav-link">Đăng xuất</a></li>
      </ul>
    </div>
  </div>
</nav>
